import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pf-compliance-grid',
  templateUrl: './pf-compliance-grid.component.html',
  styleUrls: ['./pf-compliance-grid.component.css']
})
export class PfComplianceGridComponent implements OnInit {
  title="PF Compliance";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/pf-compliances/pf-compliance-grid/pf-compliance-grid.component.ts